// 'Scroll to Top' button functionality

jQuery(function ($) {
	setupToTop($);
});

function setupToTop($) {
    var lastScroll = 0;
    const toTopButton = $('.to-top');
    
    if (toTopButton.length) {
        console.log(toTopButton);
        
        $('.to-top').click( function(event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });
        
        $( window ).scroll( function() {

			var st = $(this).scrollTop();
			var wh = $( window ).height();

			if ( wh*3 < st && st < lastScroll ){
				$('.to-top').css('right', '0');
			}
			else if( wh > st ) {
				$('.to-top').css('right', '-1000px');
			}
	        lastScroll = st;
			
		});
        
    }
}